import React, { Component } from 'react';
import API from '../services/api';
import moment from 'moment';
import './ProfileList.css';
import AuthService from '../services/auth';
import { Link } from 'react-router-dom';
import logo from '../static/images/host-icon-red.png';
import diamond from '../static/vectors/gem-black.svg';
import mask from '../static/images/host-icon.png';
import USER_STATUSES from '../constants/userStatuses';

class ProfileList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profiles: [],
    }
  }

  componentDidMount() {

    (new API()).get('/random-users' ,{}, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          profiles: response,
        });
      });
  }

  render() {
    const { profiles } = this.state;
    return (
      <div className="row profile-list">
        {profiles && profiles.map(profile => (
          <div key={profile.name} className="profile col col-6 col-md-3">
            <Link className="profile-link" to={`/member/${profile.name}`}></Link>
            <div className="image" style={{backgroundImage: `url('${profile.photo_url}')`}} >
              {profile.elite === 1 && <img src={logo} alt="Elite" />}
            </div>
            <div className={`texts ${(profile.status === USER_STATUSES.superior) ? 'superior' : ''} ${(profile.refCode && profile.refCode.length > 0 && profile.refCode !== 'disabled' && profile.refCode !== 'pending') ? 'host' : ''}`}>
              {profile.status >= USER_STATUSES.superior &&
              <div className="superior">
                <img src={diamond} alt={"diamond"} />
              </div>}
              {profile.refCode && profile.refCode.length > 0 && profile.refCode !== 'disabled' && profile.refCode !== 'pending' &&
              <div className="host">
                <img src={mask} alt={"mask"} />
              </div>}
              <div className="name">{`${profile.name}`}</div>
              <div className="other">{`${moment().diff(moment(profile.birthDate,'YYYY-MM-DD'),'years')}, ${profile.city}`}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default ProfileList;


// WEBPACK FOOTER //
// ./src/components/ProfileList.js